import type { MessageDescriptor } from '@atlassian/jira-intl';
import type { ThirdPartyFieldId } from '../../../constants/fields';
import type { ItemTypeMappingConfig } from '../types';
import {
	CLICKUP_ASSIGNEES,
	CLICKUP_CREATOR,
	CLICKUP_DESCRIPTION,
	CLICKUP_DUE_DATE,
	CLICKUP_NAME,
	CLICKUP_PRIORITY,
	CLICKUP_SPRINT_POINTS,
	CLICKUP_START_DATE,
	CLICKUP_STATUS,
	CLICKUP_SYSTEM_FIELDS,
	CLICKUP_TAGS,
	CLICKUP_TIME_ESTIMATE,
	CLICKUP_TIME_SPENT,
	CLICKUP_WATCHERS,
} from './constants';
import messages from './messages';

type FormatMessage = (message: MessageDescriptor) => string;

const getFieldNameForThirdPartyFieldId = (
	fieldType: ThirdPartyFieldId,
	formatMessage: FormatMessage,
) => {
	switch (fieldType) {
		case CLICKUP_ASSIGNEES:
			return formatMessage(messages.clickupAssignees);
		case CLICKUP_CREATOR:
			return formatMessage(messages.clickupCreator);
		case CLICKUP_WATCHERS:
			return formatMessage(messages.clickupWatchers);
		case CLICKUP_DESCRIPTION:
			return formatMessage(messages.clickupDescription);
		case CLICKUP_NAME:
			return formatMessage(messages.clickupName);
		case CLICKUP_TAGS:
			return formatMessage(messages.clickupTags);
		case CLICKUP_STATUS:
			return formatMessage(messages.clickupStatus);
		case CLICKUP_PRIORITY:
			return formatMessage(messages.clickupPriority);
		case CLICKUP_DUE_DATE:
			return formatMessage(messages.clickupDueDate);
		case CLICKUP_START_DATE:
			return formatMessage(messages.clickupStartDate);
		case CLICKUP_SPRINT_POINTS:
			return formatMessage(messages.clickupSprintPoints);
		case CLICKUP_TIME_SPENT:
			return formatMessage(messages.clickupTimeSpent);
		case CLICKUP_TIME_ESTIMATE:
			return formatMessage(messages.clickupTimeEstimate);
		default:
			return '';
	}
};

export const mapItemTypes = (
	itemTypes: ItemTypeMappingConfig[] | undefined,
	formatMessage: FormatMessage,
) => {
	if (!itemTypes) {
		return [];
	}
	return itemTypes.map((itemType) => ({
		...itemType,
		itemTypeFieldMappings: itemType.itemTypeFieldMappings.map((fieldMapping) => {
			const { fieldId, fieldName } = fieldMapping.thirdPartyField;
			return {
				...fieldMapping,
				thirdPartyField: {
					...fieldMapping.thirdPartyField,
					// We only translate system fields and retain the custom field names as is
					fieldName: CLICKUP_SYSTEM_FIELDS.includes(fieldId)
						? getFieldNameForThirdPartyFieldId(fieldId, formatMessage)
						: fieldName,
				},
			};
		}),
	}));
};
